var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('episode-detail',{attrs:{"mode":"create","show-slug":_vm.showSlug}})}
var staticRenderFns = []

export { render, staticRenderFns }